import React from 'react';
function Pages({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3L4 7l8 4 8-4-8-4zM4 17l8 4 8-4M4 12l8 4 8-4"
      />
    </svg>
  );
}

export default Pages;
